export const SET_EXCEPTIONS = 'exceptions/SET_EXCEPTIONS';

export const setExceptions = payload => ({
  type: SET_EXCEPTIONS,
  payload,
});
